(() => {
  const selector = '.byes-complete-look__media, .by-swipe-card__media, .by-swipe-result-card__image, .by-look__card-media, .by-wishlist-fallback-card .m-product-card__media';
  const badgeLabel = document.querySelector('script[data-by-flash-sale-label]')?.dataset.byFlashSaleLabel || 'SALE';
  let membership;
  let scheduled = false;
  const pending = new Set();

  async function loadMembership() {
    const ids = new Set();
    const handles = new Set();
    const pricesById = new Map();
    const pricesByHandle = new Map();
    let page = 1;
    while (page) {
      const root = window.Shopify?.routes?.root || '/';
      const url = new URL(root + 'collections/flash-sales', window.location.origin);
      url.searchParams.set('view', 'by-flash-sale-membership');
      url.searchParams.set('page', String(page));
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-cache' });
      if (!response.ok) throw new Error('Flash Sale membership unavailable');
      const data = JSON.parse(await response.text());
      if (!Array.isArray(data.products)) throw new Error('Invalid Flash Sale membership');
      data.products.forEach(product => {
        ids.add(String(product.id));
        handles.add(product.handle);
        pricesById.set(String(product.id), product.price_html);
        pricesByHandle.set(product.handle, product.price_html);
      });
      const next = Number(data.next_page);
      page = Number.isInteger(next) && next > page ? next : 0;
    }
    return { ids, handles, pricesById, pricesByHandle };
  }

  function productKey(media) {
    const look = media.closest('[data-look-product]');
    if (look) return { id: look.dataset.lookProduct };
    const card = media.closest('.byes-complete-look__card, .by-swipe-card, .by-swipe-result-card, .by-wishlist-fallback-card') || media;
    const link = card.matches('a[href]') ? card : card.querySelector('a[href*="/products/"]');
    if (!link) return {};
    const match = new URL(link.href, window.location.origin).pathname.match(/\/products\/([^/]+)/);
    return { handle: match ? decodeURIComponent(match[1]) : '' };
  }

  async function flush() {
    scheduled = false;
    const mediaItems = [...pending];
    pending.clear();
    if (!mediaItems.length) return;
    try {
      membership ||= loadMembership();
      const { ids, handles, pricesById, pricesByHandle } = await membership;
      mediaItems.forEach(media => {
        if (!media.isConnected) return;
        const key = productKey(media);
        const eligible = ids.has(String(key.id)) || handles.has(key.handle);
        const badge = media.querySelector(':scope > [data-by-flash-sale-badge]');
        const card = media.closest('[data-look-product], .byes-complete-look__card, .by-swipe-card, .by-swipe-result-card, .by-wishlist-fallback-card');
        const price = card?.querySelector('.by-look__card-price, .byes-complete-look__price, .by-swipe-card__price, .by-swipe-result-card__price, .m-product-card__price');
        const priceHtml = pricesById.get(String(key.id)) || pricesByHandle.get(key.handle);
        if (price && eligible && priceHtml && !price.querySelector('[data-by-flash-price]')) {
          price.innerHTML = priceHtml;
        }

        if (!eligible) {
          badge?.remove();
        } else if (!badge) {
          const element = document.createElement('span');
          element.className = 'by-flash-sale-badge';
          element.dataset.byFlashSaleBadge = '';
          element.textContent = badgeLabel;
          media.appendChild(element);
        }
      });
    } catch {
      membership = undefined;
    }
  }

  function scan(node) {
    if (node.nodeType !== 1 && node.nodeType !== 9) return;
    if (node.matches?.(selector)) pending.add(node);
    node.querySelectorAll(selector).forEach(media => pending.add(media));
    if (pending.size && !scheduled) {
      scheduled = true;
      queueMicrotask(flush);
    }
  }

  scan(document);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(scan));
  }).observe(document.body, { childList: true, subtree: true });
})();
